import type { DecoratedEvent } from '@/features/events/types';
import { getIntegrationDestination } from '@/features/interactions/addToCalendar/destinations/registry';
import {
  getEventExportStatus,
  type EventExportStatusInputs,
} from '@/features/interactions/lib/exportStatus.lib';
import type {
  CalendarSubscription,
  PlatformTypes,
} from '@/types/gql.generated';

type Args = {
  event: DecoratedEvent;
  platform: PlatformTypes | null;
  subscriptions: Pick<CalendarSubscription, 'platform' | 'calendarId'>[];
  inputs: EventExportStatusInputs;
};

/**
 * Whether the event sits on a calendar the whole schedule is subscribed to.
 * Those events arrive on their own, so "Added" (the word for the one-shot copy
 * the drawer makes) describes the wrong thing. Asking per subscribed calendar
 * is the only way to tell the two apart.
 */
export const isCoveredBySubscription = ({
  event,
  platform,
  subscriptions,
  inputs,
}: Args): boolean => {
  if (!platform) return false;

  // Undefined for a non-integration destination, which then matches no
  // subscription's platform.
  const exportPlatform =
    getIntegrationDestination(platform)?.integration?.exportPlatform;

  return subscriptions.some(
    (subscription) =>
      subscription.platform === exportPlatform &&
      getEventExportStatus(event, platform, inputs, {
        calendarId: subscription.calendarId,
      }).isSuccess
  );
};
